module.exports = __webpack_public_path__ + "static/media/bg-right.d893cfae.png";